import { RouterModule, Routes } from '@angular/router';
import { PlanificacionListarComponent } from './planificacion-listar/planificacion-listar.component';
import { RequerimientoCrearComponent } from './requerimiento-crear/requerimiento-crear.component';
import { RequerimientoListarComponent } from './requerimiento-listar/requerimiento-listar.component';
import { RequerimientoListarCalendarioComponent } from './requerimiento-listar-calendario/requerimiento-listar-calendario.component';

const pagesRoutes: Routes = [

  {
    path: 'planificacion-listar'
    , component: PlanificacionListarComponent

  }, {
    path: 'requerimiento-listar'
    , component: RequerimientoListarComponent

  }, {
    path: 'requerimiento-listar-calendario'
    , component: RequerimientoListarCalendarioComponent

  },
  {
    path: 'requerimiento-crear'
    , component: RequerimientoCrearComponent

  }
  ,
  {
    path: 'requerimiento-editar/:idRequerimiento', component: RequerimientoCrearComponent
  }
];

export const PLANIFICACION_ROUTES = RouterModule.forChild(pagesRoutes);